import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface SpreadsheetHubProps {
  currentLang: string;
}

export default function SpreadsheetHub({ currentLang }: SpreadsheetHubProps) {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-accent-500 text-xs font-semibold uppercase tracking-[0.15em] mb-3 block">
              Spreadsheet Hub
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-900 leading-snug mb-5">
              {t('hub_h2')}
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              {t('hub_copy')}
            </p>
            <Link
              to={`/${currentLang}/allchinabuy-spreadsheet/`}
              className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm hover:text-primary-700 transition-colors"
            >
              {t('hub_cta')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20digital%20spreadsheet%20on%20a%20tablet%20screen%20beside%20colorful%20product%20catalog%20cards%20and%20sticky%20notes%20on%20a%20bright%20desk%20workspace%20flatlay%20photography%20cheerful%20productive%20scene%20high%20detail%20clean%20composition&width=800&height=600&seq=hub-img-001&orientation=landscape&nocache=true"
              alt="AllChinaBuy Spreadsheet Hub"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/10 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}